import ShareClocks from "./share-clocks";

export default ShareClocks;